export function resolveApiBaseUrl() {
  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL;
  }
  if (typeof window !== "undefined" && window.location.hostname.includes("amvera.io")) {
    return "https://ilturismo-api-ilturismo.amvera.io/api";
  }
  return "http://localhost:5173/api";
}

export function resolveStorageBaseUrl() {
  if (import.meta.env.VITE_STORAGE_BASE_URL) {
    return import.meta.env.VITE_STORAGE_BASE_URL;
  }
  if (typeof window !== "undefined" && window.location.hostname.includes("amvera.io")) {
    return "https://ilturismo-api-ilturismo.amvera.io/storage";
  }
  return "/storage";
}
